import React, { Component } from 'react';
import get from 'lodash/get';

import WidgetPropTypes from '../types';
import AcceptTerms from '../AcceptTerms';
import css from './ProveReview.module.scss';
import Button from '../../../components/UI/Button/index.tsx';
import { terms } from '../Images';
import { isUSTimezone } from '../../../helpers';

export const WIDGET_NAME = 'prove_review';

class ProveReviewInfo extends Component {
  constructor() {
    super();

    this.state = {
      termsAccepted: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.segment.page('Registration', 'Prove Review Info');
  }

  onEnableChanged = (question, enabled) => {
    if (question === 'accept_terms') {
      this.setState({ termsAccepted: enabled });
    }
  };

  confirmInfo = () => {
    if (this.props.toggles.preventNonUSTimezones.enabled && !isUSTimezone()) {
      this.props.history.replace('/verify-hard-declined');
    } else {
      this.props.answer({
        accessToken: this.props.app.registrationToken,
        questions: [WIDGET_NAME],
        answers: [{ reviewedInfo: true }]
      });
    }
  };

  render() {
    const { index, onClick, widget } = this.props;

    const {
      setLegalFirstName,
      setLegalLastName,
      setLegalAddress,
      setUserDateOfBirth,
      setUserSsnLast4
    } = this.props.app.prefilledAnswers;

    const headerText = 'Confirm your information.';
    const subHeaderText =
      'Please confirm that your information is true and accurate. You can make any needed changes.';
    const proveReviewInfo = (
      <div data-testid="prove-compliance-info">
        <p>
          <span className={css.boldText}>Name: </span>
          {`${setLegalFirstName} ${setLegalLastName}`}
        </p>
        <p>
          <span className={css.boldText}>Date of birth: </span>
          {`${setUserDateOfBirth}`}
        </p>
        <p>
          <span className={css.boldText}>Last 4 SSN: </span>
          {`${setUserSsnLast4}`}
        </p>
        <br />

        <p className={css.boldText}>Your card(s) will be sent to:</p>
        <p>{get(setLegalAddress, 'address')}</p>
        <p>{get(setLegalAddress, 'address2')}</p>
        <p>
          {get(setLegalAddress, 'city')}, {get(setLegalAddress, 'state')}{' '}
          {get(setLegalAddress, 'zip')}
        </p>
      </div>
    );

    return (
      <div>
        <h1 data-e2e="prove-review-info-header">{headerText}</h1>
        <h2
          data-e2e="prove-review-info-subheader"
          data-testid="prove-review-info-subheader"
        >
          {subHeaderText}
        </h2>
        <div className={css.proveReviewInfoContainer}>
          <div className={`${css.proveReviewInfo} fs-mask`}>
            {proveReviewInfo}
          </div>
          <Button
            text="Edit information"
            secondary={true}
            onClick={this.props.editInfo}
          />
        </div>
        <AcceptTerms
          app={this.props.app}
          toggles={this.props.toggles}
          changeAnswerValue={this.onEnableChanged}
          index={index}
          onClick={onClick}
          shouldEnable={this.onEnableChanged}
          widget={widget}
        />
        <Button
          text="Next"
          loading={this.props.app.loading}
          onClick={this.confirmInfo}
          disabled={!this.state.termsAccepted}
        />
        {terms.legalText}
      </div>
    );
  }
}

ProveReviewInfo.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired
};

export default ProveReviewInfo;
